export enum EventLogRoleMutationType {
  ADD_SUBSEQUENT_CARRIER = 'ADD_SUBSEQUENT_CARRIER',
  UPDATE_ROLE = 'UPDATE_ROLE',
  UPDATE_LICENSE_PLATES = 'UPDATE_LICENSE_PLATES'
}
